import { CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';

interface LoadingSpinnerProps {
  isLoading: boolean;
  children: ReactNode;
}

export default function LoadingSpinner({ isLoading, children }: LoadingSpinnerProps) {
  return isLoading ? <CircularProgress /> : <>{children}</>;
}
